import { createImg, createLoadingScreen } from "../DomUtilities/ElementsCreator";

export default class ItemBaseModal {
	loadingScreen: HTMLElement;
	form: HTMLFormElement;
	subItemsCheckBox: HTMLInputElement;
	items: NodeListOf<HTMLDivElement>;
	subitemsIdsArray: string[];
	list: HTMLUListElement;
	updateImage: boolean;

	constructor() {
		this.loadingScreen = createLoadingScreen();
		this.subitemsIdsArray = new Array<string>();
		this.updateImage = false;
	}

	protected get ModalData(): { valid: boolean, itemFormData: FormData } {
		this.form = document.querySelector("#item-modal");
		const inputs = this.form.elements;
		let itemFormData = new FormData();
		let valid: boolean = this.form.checkValidity();
		for (let i = 0; i < inputs.length; i++) {
			let input = (inputs[i] as HTMLInputElement);
			if (input) {
				switch (input.name.toLowerCase()) {
					case "image":
						if (this.updateImage) {
							itemFormData.append(input.name, input.files[0]);
						}
						break;
					case "isfasttrack":
						const isFastTrack: HTMLInputElement = document.querySelector("#isFastTrack");
						itemFormData.append("isFastTrack", `${isFastTrack.checked}`);
						break;
					case "hassimpleorderflow":
						const hasSimpleOrderFlow: HTMLInputElement = document.querySelector("#hasSimpleOrderFlow");
						itemFormData.append("hasSimpleOrderFlow", `${hasSimpleOrderFlow.checked}`);
						break;
					default:
						itemFormData.append(input.name, input.value);
						break;
				}
			}
		}

		if (this.subItemsCheckBox.checked) {
			for (let i = 0; i < this.subitemsIdsArray.length; i++) {
				itemFormData.append("subItemsIds", this.subitemsIdsArray[i]);
			}
		}

		return { valid, itemFormData };
	}

	protected addUploadImageChangeEventListener() {
		const fileInput: HTMLInputElement = document.querySelector('input[name="Image"]');
		const fileDisplayArea: HTMLDivElement = document.querySelector('#pic');
		const limitSize: number = 1024 * 1024; // 1MB

		fileInput.onchange = () => {
			fileDisplayArea.innerHTML = "";
			fileInput.style.display = "block";
			fileInput.required = true;
			if (fileInput.value && fileInput.files[0]?.size < limitSize) {
				let file = fileInput.files[0];

				let reader = new FileReader();

				reader.onload = function () {
					fileDisplayArea.classList.add('open');
					fileDisplayArea.appendChild(createImg(reader.result.toString()));
				}
				this.updateImage = true;
				reader.readAsDataURL(file);
			} else {
				fileInput.value = "";
				fileDisplayArea.classList.remove('open');
				this.updateImage = false;
			}
		}
	}

	protected addSubItemsModalEventsListeners(container: HTMLDivElement) {
		const modal: HTMLDivElement = container.querySelector(`.choose-item`);
		this.items = container.querySelectorAll(`.choose-item > div > div`);
		this.subItemsCheckBox = document.querySelector("#subitems");
		const addSubItemsImg: HTMLImageElement = container.querySelector(`.modal__body img[alt="add icon"]`);
		const cancelButton: HTMLButtonElement = modal.querySelector('button');
		const saveButton: HTMLButtonElement = modal.querySelector('button + button');
		this.list = container.querySelector(`div.form-group > br + ul`);

		window.onclick = (event: MouseEvent) => {
			if (event.target === modal.previousElementSibling
				&& modal.classList.contains('choose-item__open')) {
				this.removeSubItems(modal);
			}
		}

		this.subItemsCheckBox.onchange = () => {
			if (this.subItemsCheckBox.checked) {
				modal.classList.add('choose-item__open');
			} else {
				this.removeSubItems(modal);
			}
		}

		addSubItemsImg.onclick = () => {
			modal.classList.add('choose-item__open');
		}

		this.items.forEach(item => {
			item.onclick = (event) => {
				item.classList.toggle("--selected");
				event.stopPropagation();
			}
		});

		cancelButton.onclick = () => {
			this.removeSubItems(modal);
		}

		saveButton.onclick = () => {
			const errorMessage: HTMLParagraphElement = modal.querySelector('button + button + p');
			this.saveSubItems();
			if (this.subitemsIdsArray.length > 1) {
				modal.classList.remove('choose-item__open');
				errorMessage.style.opacity = "0";
			} else {
				errorMessage.style.opacity = "1";
			}
		}
	}

	private removeSubItems(modal: HTMLDivElement) {
		modal.classList.remove('choose-item__open');
		this.subItemsCheckBox.checked = false;
		this.items.forEach(i => i.classList.remove("--selected"));
		this.list.innerHTML = "";
	}

	protected saveSubItems() {
		this.list.innerHTML = "";
		this.subitemsIdsArray.length = 0;
		this.items.forEach(item => {
			if (item.classList.contains("--selected")) {
				this.subitemsIdsArray.push(item.id);
				this.subItemsCheckBox.checked = true;
				this.fetchItemList(item);
			}
		});
	}

	private fetchItemList(item: HTMLDivElement) {
		const li = document.createElement('li');
		li.innerText = item.innerText;
		const closeImg = createImg('/assets/close_B.svg', 'close icon');
		li.appendChild(closeImg);
		this.list.appendChild(li);

		closeImg.onclick = () => {
			li.remove();
			item.classList.remove("--selected");
		}
	}
}
